// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/clockOutAlert.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-10040: ONE missed-clock-out alert default, the settings screen + the cron.)
// =============================================================================
export const CLOCK_OUT_ALERT_DEFAULTS = Object.freeze({"remindHours":24,"escalateHours":16});
export function resolveClockOutAlertHours(settings) {
  const s = settings || {};
  const remindHours = s.clockOutAlertHours || CLOCK_OUT_ALERT_DEFAULTS.remindHours;
  const escalateHours = Math.max(s.clockOutAlertEscalationHours || CLOCK_OUT_ALERT_DEFAULTS.escalateHours, remindHours);
  return { remindHours, escalateHours };
}
